import React, { useState } from 'react';
import styled from 'styled-components';

/**
 * Renders a <BrowserLocation/> component
 * @param {Object} props
 * @param {String} props.targetIcon - Url of asset to use in component
 * @param {String} props.currentProduct -Current product ID that a user is searching for
 */

const BrowserLocation = ({ targetIcon, currentProduct }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);
  const [settingUserLocation, setSettingUserLocation] = useState(false);

  const getUserLocationLoader = <Loader className="loader" />;

  const getLocationAndRedirect = ({ coords: { latitude, longitude } }) => {
    setErrorMessage('');
    setShowError(false);
    // eslint-disable-next-line max-len
    window.location.href = `/basket/collections/new?product_id=${currentProduct}&coordinates=${latitude},${longitude}`;
  };

  const logUserLocationError = () => {
    setErrorMessage(
      'An error occurred fetching your location. Please try again',
    );
    setShowError(true);
  };

  const getBrowserLocation = () => {
    if (navigator.geolocation) {
      setSettingUserLocation(true);
      navigator.geolocation.getCurrentPosition(
        getLocationAndRedirect,
        logUserLocationError,
      );
    } else {
      logUserLocationError();
    }
  };

  return (
    <>
      <UserLocation
        type="button"
        onClick={() => getBrowserLocation()}
        className="select-a-store-search__user-location fl ai-c">
        <TargetImage alt="" src={targetIcon} height={17} width={18} />
        Use my current location
        {settingUserLocation && getUserLocationLoader}
      </UserLocation>
      {showError && (
        <div className="select-a-store-search__error">
          <p>{errorMessage}</p>
        </div>
      )}
    </>
  );
};

const UserLocation = styled.button`
  margin-top: 1rem;
  color: #d02239;
  font-size: 1rem;
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  -webkit-appearance: none;
  box-shadow: none;
  border-radius: 0;
  background-color: transparent;
  border: none;
`;

const TargetImage = styled.img`
  margin-right: 0.625rem;
`;

const Loader = styled.div`
  border-top: 0.4em solid rgba(154, 153, 153, 0.5);
  border-right: 0.4em solid rgba(154, 153, 153, 0.5);
  border-bottom: 0.4em solid rgba(154, 153, 153, 0.5);
  border-left: 0.4em solid #999999;
  margin-bottom: 0;
  width: 0.75rem;
  height: 0.75rem;
  margin-left: 0.625rem;
`;

export default BrowserLocation;
